export enum AbortiveExplainStatus {
  /**
   * 待审核
   */
  WAIT_AUDIT = 0,

  /**
   * 审核通过
   */
  AUDIT_SUCCESS = 1,

  /**
   * 审核不通过
   */
  AUDIT_FAIL = 2,

  /**
   * 签署中
   */
  SIGNING = 3,

  /**
   * 签署完成
   */
  SIGNING_SUCCESS = 4
}
